import * as $ from "jquery";
import "../../lib/tooltipster.bundle.js";
import * as Modernizr from "../../lib/modernizr-3.5.0.min.js";
declare global {
	interface Window {
		dataLayer:any;
	}
}

function trackTooltipContent(tooltipContent){
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		'tooltipValue' : tooltipContent, //Insert the value of the tooltip
		'event' : 'help_tooltip'
	});
	// console.log(window.dataLayer);
}

function initTooltips() {
	$('.js-tooltip').not('.tooltipstered').each(function () {
		let $this = $(this);

		// Each tooltip can have a data-content attribute with the selector of the DOM element that contains the content.
		// If no data-tooltip-content is specified, Tooltips will use the "title" attribute instead
		let $contentTarget = $( $this.data('tooltip-content'));

		if($this.attr('title')) {
			$this.attr('data-content', $this.attr('title'));
		} else if ($contentTarget.length) {
			$this.attr('data-content', $contentTarget.text().trim());
		}

		if (!$contentTarget.length && !this.hasAttribute('title')) { return; }

		let config: any = {
			trigger: Modernizr.coarsepointer ? 'click' : 'hover',
			animation: 'fade',
			maxWidth: 300,
			interactive: true,
			delay: 200,
			theme: 'tooltipster-light',
			contentAsHTML: true
		};

		if ($contentTarget.length) {
			config.content = $contentTarget.html();
			config.contentAsHTML = true;
		}

		$this.tooltipster(config);

	}).on('click', function(e) {
		let $this = $(this);
		trackTooltipContent($this.data('content'));
		e.preventDefault();
	}).on('mouseenter', function(){
		let $this = $(this);
		trackTooltipContent($this.data('content'));
	});
}

export function init() {
	initTooltips();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/tooltips.ts